export default __webpack_public_path__ + "static/media/Forest_01.60780d21.png";